import { AbstractControl, ValidationErrors } from "@angular/forms";

export function birthDateValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;

  if (!value) {
    return { invalidDate: true };
  }

  let dataString = '';

  // Se o datepicker retornar Date, converta para string "DDMMYYYY"
  if (value instanceof Date) {
    const dia = String(value.getDate()).padStart(2, '0');
    const mes = String(value.getMonth() + 1).padStart(2, '0');
    const ano = String(value.getFullYear());
    dataString = `${dia}${mes}${ano}`;
  } else if (typeof value === 'string') {
    // Remove tudo que não for dígito
    dataString = value.replace(/\D/g, '');
  } else {
    return { invalidDate: true };
  }

  // minlength: se ainda não tiver 8 dígitos, não valida a data ainda
  if (dataString.length < 8) {
    return { minlength: true };
  }

  // Pega dia / mês / ano
  const dia = parseInt(dataString.slice(0, 2), 10);
  const mes = parseInt(dataString.slice(2, 4), 10);
  const ano = parseInt(dataString.slice(4, 8), 10);

  return validateDate(dia, mes, ano);
}

function validateDate(
  dia: number,
  mes: number,
  ano: number
): { [key: string]: boolean } | null {
  // Mês válido
  if (mes < 1 || mes > 12) {
    return { invalidDate: true };
  }

  // Dia válido para o mês/ano
  const diasNoMes = getDayInMonth(mes, ano);
  if (dia < 1 || dia > diasNoMes) {
    return { invalidDate: true };
  }

  const dataInformada = new Date(ano, mes - 1, dia);

  // Limite inferior: a partir de 01/01/1901 (inclusive)
  const minDate = new Date(1901, 0, 1); // 01/01/1901
  if (dataInformada < minDate) {
    return { invalidDate: true };
  }

  // Limite superior: ontem ou antes (hoje e futuro bloqueados)
  const hoje = new Date();
  const hojeSemHora = new Date(
    hoje.getFullYear(),
    hoje.getMonth(),
    hoje.getDate()
  );

  // Se for hoje ou depois de hoje, erro de data futura
  if (dataInformada >= hojeSemHora) {
    return { futureDate: true }; // mesmo erro usado para data futura
  }

  return null;
}

function getDayInMonth(mes: number, ano: number): number {
  const diasPorMes = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  if (mes === 2) {
    const isLeapYear =
      (ano % 4 === 0 && ano % 100 !== 0) || ano % 400 === 0;
    if (isLeapYear) {
      return 29;
    }
  }

  return diasPorMes[mes - 1];
}
